import type { AxiosInstance } from "axios";
import { API_URL, DATA_URL } from "~/env";
import { sendRequest } from "~/utils/axios-utils";

export default ($axios: AxiosInstance) => {
  // 设置 baseURL
  // 注意：这里我们使用 defaults.baseURL 而不是 setBaseURL 方法
  if (process.env.NODE_ENV === "development") {
    $axios.defaults.baseURL = API_URL;
  }

  return {
    /**
     * 获取法搜会员信息
     */
    onDataCheckExpire: () =>
      sendRequest($axios, {
        method: "GET",
        url: `${DATA_URL}/api/v2/pay/checkExpire`,
      }),

    /**
     * 查询我的积分详情
     */
    queryPointsRuleList: () =>
      sendRequest($axios, {
        method: "GET",
        url: "/api/v1/points/queryPointsRuleList",
      }),

    /**
     * 查询我的积分详情
     */
    queryMyPointsInfo: () =>
      sendRequest($axios, {
        method: "GET",
        url: "/api/v1/points/queryMyPointsInfo",
      }),

    /**
     * 积分签到
     */
    onPointsSignIn: (params: { type: "1" | "2" }) =>
      sendRequest($axios, {
        method: "POST",
        url: "/api/v1/points/pointsSignIn",
        data: params,
      }),

    /**
     * 添加六个月会员
     */
    giveVip: (params: Record<string, string>) => {
      // 在 Axios 中，我们需要使用 defaults.headers 来设置头部
      const headers = {
        otherRegisterPlatform: params?.value,
      };

      sendRequest($axios, {
        method: "GET",
        url: "/api/v1/other_platform/giveVip",
        headers,
      });
    },
  };
};
